// Handle My Affairs — progressive "Read full review" control.
// Without this script the full review text is always visible (no-JS-safe
// baseline). With it, long reviews get a mobile-only clamp + toggle.
(function () {
  var toggles = document.querySelectorAll('[data-review-toggle]');

  toggles.forEach(function (button) {
    var bodyId = button.getAttribute('aria-controls');
    var body = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;

    button.hidden = false;
    body.classList.add('hma-reader-reviews__body--collapsed');
    button.setAttribute('aria-expanded', 'false');

    var moreLabel = button.querySelector('[data-label-more]');
    var lessLabel = button.querySelector('[data-label-less]');

    button.addEventListener('click', function () {
      var isCollapsed = body.classList.toggle('hma-reader-reviews__body--collapsed');
      button.setAttribute('aria-expanded', String(!isCollapsed));
      if (moreLabel) moreLabel.hidden = !isCollapsed;
      if (lessLabel) lessLabel.hidden = isCollapsed;
    });
  });
})();
